/**
 * The values of this enum are based on the ids of our `sd_countries` database table
 */
export enum CountryId {
    GERMANY = 64,
}
